import { Button, Flex, Stack, useTheme, spacing } from '@fti/design-system';
import { useState } from 'react';
import { MessageForm } from './MessageForm';
import type { Message, MessageUpdateRequest } from '../../../types/media-sim';

interface MessageDetailProps {
  message: Message;
  onUpdate: (data: MessageUpdateRequest) => void;
  onRegister: () => void;
  onDuplicate: () => void;
  onBack: () => void;
}

export function MessageDetail({
  message,
  onUpdate,
  onRegister,
  onDuplicate,
  onBack,
}: MessageDetailProps) {
  const { theme } = useTheme();
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <Stack gap="md">
      <Flex justify="between" align="center">
        <Button variant="ghost" onClick={onBack}>
          &larr; Back to Messages
        </Button>
        <Flex gap="sm">
          {message.status === 'draft' && (
            <Button
              variant="outline"
              color="primary"
              onClick={() => setShowConfirm(true)}
            >
              Register
            </Button>
          )}
          {message.status === 'registered' && (
            <Button variant="ghost" onClick={onDuplicate}>
              Duplicate
            </Button>
          )}
        </Flex>
      </Flex>

      <MessageForm message={message} onSave={onUpdate} />

      {showConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}
          onClick={() => setShowConfirm(false)}
        >
          <div
            style={{
              backgroundColor: theme.colors.background.paper,
              borderRadius: '8px',
              padding: spacing.lg,
              maxWidth: 400,
              width: '100%',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Stack gap="md">
              <h2 style={{ margin: 0, fontSize: '1.1rem' }}>Register Message</h2>
              <p style={{ margin: 0 }}>
                Once registered, this message cannot be edited. Continue?
              </p>
              <Flex gap="sm" justify="end">
                <Button variant="ghost" onClick={() => setShowConfirm(false)}>
                  Cancel
                </Button>
                <Button
                  variant="solid"
                  color="primary"
                  onClick={() => {
                    setShowConfirm(false);
                    onRegister();
                  }}
                >
                  Register
                </Button>
              </Flex>
            </Stack>
          </div>
        </div>
      )}
    </Stack>
  );
}
